'use client'

import { useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import parse from 'html-react-parser'
import { isEmpty } from 'lodash'

import { PrimaryButton } from '@/components/buttons'
import { SlideCarousel } from '@/components/carousel/SlideCarousel'
import { useIsMobile } from '@/hooks/useIsMobile'
import { cmsImageSrc } from '@/utils/cmsImageSrc'

function Deals({ dealsData }) {
  const [currentSlide, setSlide] = useState(0)
  const isMobileSize = useIsMobile({ maxWidth: 767 })

  const scrollToInstallApp = () => {
    const element = document.getElementById('install-app')

    if (element) {
      const yOffset = isMobileSize ? -100 : -140
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo({ top: y, behavior: 'smooth' })
    }
  }

  const slides = isEmpty(dealsData)
    ? []
    : dealsData.map(content => (
        <img
          key={content.title}
          src={cmsImageSrc(content.image || content.imageLink)}
          style={{
            maxHeight: '500px',
            objectFit: 'contain'
          }}
          alt="Deal Image"
          className="deal-image"
        />
      ))

  const content = isEmpty(dealsData)
    ? []
    : dealsData.map(content => (
        <div key={content.title} className="text-center text-md-start">
          <div>
            <h1>{typeof content.title === 'string' ? parse(content.title) : content.title}</h1>
          </div>
          <div className="my-4 short-desc">
            <span>
              {typeof content.description === 'string'
                ? parse(content.description)
                : content.description}
            </span>
          </div>
          {isMobileSize ||
            (content.button && (
              <PrimaryButton
                text={content.button}
                onClick={scrollToInstallApp}
                classname="link-button mt-3 mb-3 fs-14"
              />
            ))}
        </div>
      ))

  return (
    <div className="hero-container">
      <Container fluid className="container">
        <Row className="flex-column-reverse flex-md-row text-center text-md-start">
          <Col md="5" data-aos="fade-right" className="align-self-center">
            {/* Only this half runs the autoplay timer; the text carousel below
                follows the shared index. Two independent timers (what RRC did)
                can drift apart, which is the one way a synced pair desyncs. */}
            <SlideCarousel autoPlay loop index={currentSlide} onIndexChange={setSlide}>
              {slides}
            </SlideCarousel>
          </Col>
          <Col md="7" className="align-self-center px-md-5 mb-5 mb-md-0">
            <div data-aos="fade-left">
              {dealsData.length > 1 && (
                <div className="d-inline-flex justify-content-between pb-3">
                  {dealsData.map((_, index) => (
                    <div
                      key={`dot-${index}`}
                      onClick={() => setSlide(index)}
                      className={` rounded-circle p-1 mx-1 cursor-pointer ${
                        index === currentSlide
                          ? `primary-background`
                          : isMobileSize
                            ? `grey-background`
                            : `bg-white`
                      }`}
                    />
                  ))}
                </div>
              )}
              <SlideCarousel loop index={currentSlide} onIndexChange={setSlide}>
                {content}
              </SlideCarousel>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Deals
